import styled from 'styled-components';
import { Spacing } from 'web-common/src/shared/styles';

export const SpiceLevelContainer = styled.div`
  overflow-x: auto;
  width: 100%;

  & button {
    flex: 1;
    min-width: 100px;
    max-width: 100px;
    & > * {
      padding: ${Spacing.SINGLE} 0 !important;
    }
  }
`;
